<template>
  <section id="content">
    <!--start container-->
    <div class="container">
      <h1>Subir archivos</h1>
      <div class="content_drop_zone">
        <vue-dropzone
          ref="myVueDropzone"
          id="dropzone"
          :options="dropzoneOptions"
          v-on:vdropzone-sending="sendingEvent"
          v-on:vdropzone-complete="completeUploadFile"
          v-on:vdropzone-queue-complete="sendingComplete"
          v-on:vdropzone-error="failed"
          @vdropzone-files-added="vfilesAdded"
        ></vue-dropzone>
      </div>
      <p>
        Total de archivos a subir:
        <strong>{{files.length}}</strong>
      </p>
      <table class="striped responsive-table archivos">
        <thead>
          <tr>
            <td>Nombre</td>
            <td>Clasificación</td>
            <td>Tamaño</td>
            <td>Acciones</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="file in files" :key="file.id">
            <td>
              <a class="adjunto">
                <i class="material-icons left">insert_drive_file</i>
                {{ file.name }}
              </a>
            </td>
            <td>{{ file.type }}</td>
            <td>{{ file.size }}</td>
            <td>
              <a
                @click="removeFileToUpload(file)"
                href="#"
                class="bottom icon delete tooltipped"
                data-position="left"
                data-tooltip="Eliminar archivo"
              >
                <i class="material-icons">delete</i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="input-field col right">
          <button class="btn waves-effect waves-light" @click="uploadFiles()">
            <i class="material-icons left">file_upload</i> Subir archivos
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { helpersMixin } from "../../mixins/helpers";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import EnvProvider from 'jvjr-docker-env';

export default {
  name: "dropzone",
  mixins: [helpersMixin],
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      dropzoneOptions: {
        url: EnvProvider.value('FIRMADOR_API_URL') + "fmng/upload",
        thumbnailWidth: 50,
        maxFilesize: EnvProvider.value('MAX_UPLOAD_SIZE') || 100000,
        headers: {
          Authorization: this.$store.state.api_token,
        },
        autoProcessQueue: false,
        acceptedFiles: EnvProvider.value('IRMADOR_EXTENSIONES_HABILITADAS') || ".pdf, application/pdf",
        dictDefaultMessage:
          "Arrastre aquí los archivos a subir <br><br><button class='waves-effect waves-light  btn' >Si prefiere puede seleccionarlos desde aquí</button>",
      },
      filesToUpload: [],
      files: [],
      filesResponses: [],
      fileDropzoneError: "",
    };
  },
  computed: {},
  methods: {
    removeFileToUpload(file) {
      this.filesToUpload.splice(this.filesToUpload.indexOf(file), 1);
      this.files.splice(this.files.indexOf(file), 1);
      this.$refs.myVueDropzone
        .getQueuedFiles()
        .splice(this.$refs.myVueDropzone.getQueuedFiles().indexOf(file), 1);
    },
    vfilesAdded(files) {
      files.forEach((file, index) => {
        this.files.push({
          id: index + 1,
          name: file.name,
          type: file.type,
          size: helpersMixin.methods.formatBytes(file.size),
        });
      });
      this.filesToUpload.push(files);
    },
    uploadFiles() {
      this.$refs.myVueDropzone.processQueue();
    },
    completeUploadFile(response) {
      this.filesResponses.push(response.name + " " + response.status);
    },
    failed: function (file, message, xhr) {
      let response = xhr.response;
      let parse = JSON.parse(response, (key, value) => {
        return value;
      });
      this.fileDropzoneError = parse.message;
    },
    sendingComplete() {
      let html = "";
      let allOk = true;
      this.filesResponses.forEach((item) => {
        allOk = item.includes("success") && allOk;
        item = item.replace(
          "success",
          "<p class='exito'><i class='material-icons'>done</i> El archivo se subió exitosamente.</p>"
        );
        item = item.replace(
          "error",
          " <p class='error'><i class='material-icons'>error</i> Hubo un error al subir el archivo.</p><p>" +
            this.fileDropzoneError +
            "</p>"
        );
        html += "<div>" + item + "</div>";
      });
      this.$fire({
        title: "Detalle de la operación",
        html: html,
        type: allOk ? "success" : "warning",
        showConfirmButton: true,
      }).then((r) => {
        if (r.value) {
          this.$router.push({ name: "firmar" });
        }
      });
    },
    sendingEvent(file, xhr, formData) {
      formData.append("agente", this.$store.state.agente.username);
    },
  },
};
</script>